var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconMail = function SvgIconMail(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 19,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#icon-mail_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.375.956H1.625c-.431 0-.844.158-1.149.439A1.444 1.444 0 0 0 0 2.455v15c0 .398.171.78.476 1.061.305.282.718.44 1.149.44h22.75c.431 0 .844-.159 1.149-.44.305-.281.476-.663.476-1.06v-15c0-.398-.171-.78-.476-1.061a1.696 1.696 0 0 0-1.149-.44Zm-1.251 16.5H2.974l5.687-5.43-1.17-1.043-5.866 5.603V3.596l10.1 9.277c.304.28.716.436 1.145.436.43 0 .841-.157 1.146-.436l10.359-9.51v13.125l-5.98-5.52-1.146 1.058 5.875 5.43Zm-20.435-15h20.37L12.87 11.808 2.69 2.456Z",
    fill: "#fff"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "icon-mail_svg__a",
    x: 0,
    y: 0.956,
    width: 26,
    height: 18.5,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0.360784 0 0 0 0 0.541176 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "shape",
    result: "effect1_innerShadow_1713_46238"
  })))));
};
export default SvgIconMail;